import React, {
  useState,
  useCallback,
  createContext,
  ReactElement,
} from 'react'
import Snackbar from '@mui/material/Snackbar'
import Alert from '@mui/lab/Alert'

export interface ISnackbarContext {
  open: boolean
  toggleSnackbar: (message: string, alertVariant?: AlertType) => void
}

type AlertType = 'error' | 'success' | 'info' | 'warning' | undefined

const SnackbarContext = createContext<ISnackbarContext>({
  open: false,
  toggleSnackbar: (message: string) => {
    console.error('No Provider | Snackbar message: ', message)
  },
})

export type SnackbarProviderProps = LAW.Props.IDefault

export function SnackbarProvider({
  children,
}: SnackbarProviderProps): ReactElement {
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState('')
  const [alertVariant, setAlertVariant] = useState<AlertType>('error')

  const toggleSnackbar = useCallback(
    (message: string, alertVariant?: AlertType) => {
      setMessage(message)
      setAlertVariant(alertVariant || 'info')
      setOpen(true)
    },
    [],
  )

  function handleClose() {
    setOpen(false)
  }

  return (
    <SnackbarContext.Provider
      value={{ open: open, toggleSnackbar: toggleSnackbar }}
    >
      {children}
      <Snackbar open={open} onClose={handleClose} autoHideDuration={6000}>
        <Alert elevation={6} variant="filled" severity={alertVariant}>
          {message}
        </Alert>
      </Snackbar>
    </SnackbarContext.Provider>
  )
}

SnackbarProvider.whyDidYouRender = true

export default SnackbarContext
